<label *ngIf="label" [for]="inputId">
  <input
    type="radio"
    [id]="inputId"
    [name]="name"
    [value]="value"
    [checked]="checked"
    [disabled]="disabled"
    [tabindex]="tabindex"
    (change)="onChange()"
    (blur)="onBlur($event)" />
  {{ label | translate }}
</label>
